import React from 'react';
import { LucideIcon } from 'lucide-react';

interface AnimatedBorderBadgeProps {
  text: string;
  icon?: LucideIcon;
  align?: 'left' | 'center';
}

const AnimatedBorderBadge: React.FC<AnimatedBorderBadgeProps> = ({ text, icon: Icon, align = 'center' }) => {
  return (
    <div className={`flex ${align === 'left' ? 'justify-start' : 'justify-center'} pt-2 pb-6`}>
      <div className="relative inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full overflow-hidden">
        {/* Animated border - rotating gradient (uses global CSS) */}
        <div className="absolute inset-0 rounded-full badge-animated-border" />
        
        {/* Static border underneath (uses global CSS) */}
        <div className="absolute inset-0 rounded-full badge-static-border" />
        
        {/* Inner background (uses global CSS) */}
        <div className="absolute inset-[1px] rounded-full badge-inner-bg" />
        
        {/* Icon */}
        {Icon && (
          <Icon 
            className="relative z-10 w-3 h-3" 
            style={{ color: 'var(--badge-icon)' }} 
          />
        )}
        
        {/* Text content */}
        <span 
          className="relative z-10 text-xs font-medium"
          style={{ color: 'var(--badge-text)' }}
        >
          {text}
        </span>
      </div>
    </div>
  );
};

export default AnimatedBorderBadge;
